import { useAccountConfig } from 'config';

export default ({ value, plural = false, prefix = null, fallback }) => {
  const { translate } = useAccountConfig();
  return translate({ value, plural, prefix, fallback });
};
